import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { clientContactPersonQueries } from "~/modules/client/api/clientContactPerson/clientContactPersonQueries.ts";
import CreateClientContactPersonForm from "~/modules/client/components/contact/forms/CreateClientContactPersonForm";

type AddContactPersonToClientSidebarProps = {
	isOpen: boolean;
	setOpen: (open: boolean) => void;
	clientId: string;
	companyId: string;
};

const AddContactPersonToClientSidebar: FunctionComponent<AddContactPersonToClientSidebarProps> = ({
	isOpen,
	setOpen,
	clientId,
	companyId,
}) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(() => {
		queryClient.invalidateQueries({ queryKey: clientContactPersonQueries.byClient(clientId).queryKey });
		queryClient.invalidateQueries({ queryKey: clientContactPersonQueries.all().queryKey });
		setOpen(false);
	}, [queryClient, clientId, setOpen]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => setOpen(!isOpen)}>
			<CreateClientContactPersonForm
				clientId={clientId}
				companyId={companyId}
				onSuccess={handleSuccess}
				onCancel={() => setOpen(false)}
			/>
		</Sidebar>
	);
};

export default AddContactPersonToClientSidebar;
